var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProyectosNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.8125C4.3125 2.8125 3.75 3.23438 3.75 3.75V26.25C3.75 26.7656 4.3125 27.1875 5 27.1875H11.25V23.4375C11.25 21.8848 12.9297 20.625 15 20.625C17.0703 20.625 18.75 21.8848 18.75 23.4375V27.1875H25C25.6875 27.1875 26.25 26.7656 26.25 26.25V3.75C26.25 3.23438 25.6875 2.8125 25 2.8125H5ZM0 3.75C0 1.68164 2.24219 0 5 0H25C27.7578 0 30 1.68164 30 3.75V26.25C30 28.3184 27.7578 30 25 30H5C2.24219 30 0 28.3184 0 26.25V3.75ZM6.875 6.09375C6.875 5.57812 7.4375 5.15625 8.125 5.15625H11.875C12.5625 5.15625 13.125 5.57812 13.125 6.09375V8.90625C13.125 9.42188 12.5625 9.84375 11.875 9.84375H8.125C7.4375 9.84375 6.875 9.42188 6.875 8.90625V6.09375ZM18.125 5.15625H21.875C22.5625 5.15625 23.125 5.57812 23.125 6.09375V8.90625C23.125 9.42188 22.5625 9.84375 21.875 9.84375H18.125C17.4375 9.84375 16.875 9.42188 16.875 8.90625V6.09375C16.875 5.57812 17.4375 5.15625 18.125 5.15625ZM6.875 13.5938C6.875 13.0781 7.4375 12.6562 8.125 12.6562H11.875C12.5625 12.6562 13.125 13.0781 13.125 13.5938V16.4062C13.125 16.9219 12.5625 17.3438 11.875 17.3438H8.125C7.4375 17.3438 6.875 16.9219 6.875 16.4062V13.5938ZM18.125 12.6562H21.875C22.5625 12.6562 23.125 13.0781 23.125 13.5938V16.4062C23.125 16.9219 22.5625 17.3438 21.875 17.3438H18.125C17.4375 17.3438 16.875 16.9219 16.875 16.4062V13.5938C16.875 13.0781 17.4375 12.6562 18.125 12.6562Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyectosNa);
export default __webpack_public_path__ + "static/media/ProyectosNA.9a194ea16b0c9e391f78224e2a8fcd58.svg";
export { ForwardRef as ReactComponent };